var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFromCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.207 1.5C14.4832 1.5 14.707 1.72386 14.707 2V14C14.707 14.2761 14.4832 14.5 14.207 14.5H2.20703C1.93089 14.5 1.70703 14.2761 1.70703 14V10.3333C1.70703 10.0572 1.48317 9.83333 1.20703 9.83333C0.930889 9.83333 0.707031 10.0572 0.707031 10.3333V14C0.707031 14.8284 1.3786 15.5 2.20703 15.5H14.207C15.0355 15.5 15.707 14.8284 15.707 14V2C15.707 1.17157 15.0355 0.5 14.207 0.5H9.20703C8.93089 0.5 8.70703 0.723858 8.70703 1C8.70703 1.27614 8.93089 1.5 9.20703 1.5H14.207Z",
    fill: "#1D1D46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20703 10.4004C7.93089 10.4004 7.70703 10.1765 7.70703 9.90039V6.50039C7.70703 5.67196 7.03546 5.00039 6.20703 5.00039H2.41414L4.06059 6.64684C4.25585 6.8421 4.25585 7.15868 4.06059 7.35394C3.86532 7.54921 3.54874 7.54921 3.35348 7.35394L0.499925 4.50039L3.35348 1.64684C3.54874 1.45158 3.86532 1.45158 4.06059 1.64684C4.25585 1.8421 4.25585 2.15868 4.06059 2.35394L2.41414 4.00039H6.20703C7.58774 4.00039 8.70703 5.11968 8.70703 6.50039V9.90039C8.70703 10.1765 8.48317 10.4004 8.20703 10.4004Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromCompany);
export default __webpack_public_path__ + "static/media/from-company.a8e371f5c13a40ce9f17584163987f30.svg";
export { ForwardRef as ReactComponent };